"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EN_TITLE_RGB_COLOR = void 0;
/**
 * 타이틀 텍스트 색상 RGB CODE
 * Yanolja: UI Kit 색상 포함
 * https://app.zeplin.io/project/6007c3c33353b127a9c3adec/styleguide/colors?cid=6304aac7c955801279c85d1f
 */
var EN_TITLE_RGB_COLOR;
(function (EN_TITLE_RGB_COLOR) {
    /** 야놀자케어 색상값 */
    EN_TITLE_RGB_COLOR["CARE_GREEN"] = "#18a34d";
    EN_TITLE_RGB_COLOR["YA_PINK"] = "#de2e5f";
    EN_TITLE_RGB_COLOR["YA_BLUE"] = "#0152cc";
    EN_TITLE_RGB_COLOR["YA_BLUE_5"] = "#f2f6fc";
    EN_TITLE_RGB_COLOR["YA_BLUE_20"] = "#ccdcf5";
    EN_TITLE_RGB_COLOR["YA_BLUE_40"] = "#99baeb";
    EN_TITLE_RGB_COLOR["YA_BLUE_50"] = "#80a8e5";
    EN_TITLE_RGB_COLOR["YA_BLUE_70"] = "#4d85db";
    EN_TITLE_RGB_COLOR["YA_YELLOW"] = "#fdbd00";
    EN_TITLE_RGB_COLOR["YA_ORANGE"] = "#e67000";
    EN_TITLE_RGB_COLOR["YA_RED"] = "#dc0328";
    EN_TITLE_RGB_COLOR["YA_GREEN"] = "#008161";
    EN_TITLE_RGB_COLOR["REST_ORANGE"] = "#f67247";
    EN_TITLE_RGB_COLOR["GRAY_50"] = "#f8f8f8";
    EN_TITLE_RGB_COLOR["GRAY_100"] = "#f2f2f2";
    EN_TITLE_RGB_COLOR["GRAY_200"] = "#e6e6e6";
    EN_TITLE_RGB_COLOR["GRAY_400"] = "#cccccc";
    /** 레저 상품 > 판매완료 등에 사용 */
    EN_TITLE_RGB_COLOR["GRAY_600"] = "#919191";
    /** 레저 상품 > 판매완료 등에 사용 */
    EN_TITLE_RGB_COLOR["GRAY_700"] = "#616161";
    /** 국내숙소 상품 > 다른 날짜로 가격확인 등에 사용 */
    EN_TITLE_RGB_COLOR["GRAY_900"] = "#1a1a1a";
    EN_TITLE_RGB_COLOR["BLACK"] = "#000000";
    EN_TITLE_RGB_COLOR["WHITE"] = "#ffffff";
})(EN_TITLE_RGB_COLOR = exports.EN_TITLE_RGB_COLOR || (exports.EN_TITLE_RGB_COLOR = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRU5fVElUTEVfUkdCX0NPTE9SLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL3NhcHBvcm8vY29uc3RhbnQvZW51bS90ZXh0L0VOX1RJVExFX1JHQl9DT0xPUi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQTs7OztHQUlHO0FBQ0gsSUFBWSxrQkEyQlg7QUEzQkQsV0FBWSxrQkFBa0I7SUFDNUIsZ0JBQWdCO0lBQ2hCLDRDQUFzQixDQUFBO0lBQ3RCLHlDQUFtQixDQUFBO0lBQ25CLHlDQUFtQixDQUFBO0lBQ25CLDJDQUFxQixDQUFBO0lBQ3JCLDRDQUFzQixDQUFBO0lBQ3RCLDRDQUFzQixDQUFBO0lBQ3RCLDRDQUFzQixDQUFBO0lBQ3RCLDRDQUFzQixDQUFBO0lBQ3RCLDJDQUFxQixDQUFBO0lBQ3JCLDJDQUFxQixDQUFBO0lBQ3JCLHdDQUFrQixDQUFBO0lBQ2xCLDBDQUFvQixDQUFBO0lBQ3BCLDZDQUF1QixDQUFBO0lBQ3ZCLHlDQUFtQixDQUFBO0lBQ25CLDBDQUFvQixDQUFBO0lBQ3BCLDBDQUFvQixDQUFBO0lBQ3BCLDBDQUFvQixDQUFBO0lBQ3BCLHlCQUF5QjtJQUN6QiwwQ0FBb0IsQ0FBQTtJQUNwQix5QkFBeUI7SUFDekIsMENBQW9CLENBQUE7SUFDcEIsa0NBQWtDO0lBQ2xDLDBDQUFvQixDQUFBO0lBQ3BCLHVDQUFpQixDQUFBO0lBQ2pCLHVDQUFpQixDQUFBO0FBQ25CLENBQUMsRUEzQlcsa0JBQWtCLEdBQWxCLDBCQUFrQixLQUFsQiwwQkFBa0IsUUEyQjdCIn0=